import axios from 'axios';
import {getApiConfig} from '../config/configProvider';
import {ANALYTICS_EVENTS} from '../constants/constants';

const testBuildFails = {};

export default class analyticsApi {
  static async pageview(url, timeStamp, userInfo, extra) {
    const config = getApiConfig();
    let pageReferrer;
    if (typeof window !== 'undefined') {
      pageReferrer = document.referrer;
    }
    const data = {
      timeStamp,
      userInfo,
      event: 'pageview',
      url,
      deviceHash: userInfo.deviceHash,
      pageReferrer,
      ...(extra || {}),
    };
    return axios
      .post((userInfo.domain || '') + config.analyticsUrl, data, {
        headers: {version: 2},
      })
      .then(res => res.data)
      .catch(e => e);
  }

  static async errorEvent(event, description, error, timeStamp, userInfo) {
    const config = getApiConfig();
    let pageReferrer;
    if (typeof window !== 'undefined') {
      pageReferrer = document.referrer;
    }
    const data = {
      timeStamp,
      userInfo,
      event,
      description,
      error,
      deviceHash: userInfo.deviceHash,
      pageReferrer,
    };
    return axios
      .post((userInfo.domain || '') + config.analyticsUrl, data, {
        headers: {version: 2},
      })
      .then(res => res.data)
      .catch(e => e);
  }

  static async trackEvent(event, payload, timeStamp) {
    const config = getApiConfig();
    // Copy rather than mutate the caller's payload (see
    // GoogleAnalyticsHelper.trackEvent).
    const params =
      typeof window !== 'undefined' && payload
        ? {
            ...payload,
            page_referrer:
              window && window.document && window.document.referrer,
          }
        : payload;
    let {userInfo, ...eventParams} = params || {};
    if (!userInfo) {
      userInfo = {};
    }

    const data = {
      eventParams,
      userInfo,
      event,
      timeStamp,
    };
    return axios
      .post((userInfo.domain || '') + config.analyticsUrl, data, {
        headers: {version: 2},
      })
      .then(res => res.data)
      .catch(e => e);
  }

  static async identifyProduct(event, product, timeStamp, userInfo) {
    const config = getApiConfig();
    let pageReferrer;
    if (typeof window !== 'undefined') {
      pageReferrer = document.referrer;
    }
    const data = {
      timeStamp,
      userInfo,
      event,
      product,
      deviceHash: userInfo.deviceHash,
      pageReferrer,
    };
    return axios
      .post((userInfo.domain || '') + config.analyticsUrl, data, {
        headers: {version: 2},
      })
      .then(res => res.data)
      .catch(e => e);
  }

  static async addProduct(
    event,
    product,
    quantity,
    source,
    isDelivery,
    action = ANALYTICS_EVENTS.ADD_PRODUCT,
    timeStamp,
    userInfo,
    searchId,
    searchPosition
  ) {
    const config = getApiConfig();
    let pageReferrer;
    if (typeof window !== 'undefined') {
      pageReferrer = document.referrer;
    }
    const data = {
      timeStamp,
      userInfo,
      event,
      product,
      action,
      quantity,
      source,
      isDelivery,
      deviceHash: userInfo.deviceHash,
      pageReferrer,
      searchId,
      searchPosition,
    };
    return axios
      .post((userInfo.domain || '') + config.analyticsUrl, data, {
        headers: {version: 2},
      })
      .then(res => res.data)
      .catch(e => e);
  }

  static async removeProduct(
    event,
    product,
    action = ANALYTICS_EVENTS.REMOVE_PRODUCT,
    timeStamp,
    userInfo,
    searchId,
    searchPosition
  ) {
    const config = getApiConfig();
    let pageReferrer;
    if (typeof window !== 'undefined') {
      pageReferrer = document.referrer;
    }
    const data = {
      timeStamp,
      userInfo,
      event,
      product,
      action,
      deviceHash: userInfo.deviceHash,
      pageReferrer,
      searchId,
      searchPosition,
    };
    return axios
      .post((userInfo.domain || '') + config.analyticsUrl, data, {
        headers: {version: 2},
      })
      .then(res => res.data)
      .catch(e => e);
  }
}
